import { createURL, type QueryParamsArg } from '@jwp/ott-common/src/utils/urlFormatting';
import type { Location } from 'react-router-dom';

// Elimina o comenta este import si no existe
// import type { AccountModals } from '../containers/AccountModal/AccountModal';

export const createURLFromLocation = (location: Location, queryParams: QueryParamsArg = {}) => {
  return createURL(`${location.pathname}${location.search || ''}`, queryParams);
};

// Cambia 'u' a string | null para que nunca sea symbol
export const modalURLFromLocation = (location: Location, u: string | null, queryParams: QueryParamsArg = {}) => {
  return createURL(`${location.pathname}${location.search || ''}`, { u, ...queryParams } as Record<string, string | number | string[] | null | undefined>);
};

// Igual para la versión de window.location
export const modalURLFromWindowLocation = (u: string, queryParams: QueryParamsArg = {}) => {
  return createURL(window.location.href, { u, ...queryParams } as Record<string, string | number | string[] | null | undefined>);
};
